import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Heading = _resolveComponent("Heading")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Paragraph = _resolveComponent("Paragraph")!
  const _component_Grid = _resolveComponent("Grid")!

  return (_openBlock(), _createBlock(_component_Grid, null, {
    default: _withCtx(() => [
      _createVNode(_component_Column, { span: [ 2, 3 ] }, {
        default: _withCtx(() => [
          _createVNode(_component_Heading, {
            tag: "h2",
            innerHTML: _ctx.title
          }, null, 8, ["innerHTML"]),
          _createVNode(_component_Button, {
            class: "mt-12",
            route: _ctx.link?.slug ?? _ctx.Route.Contact
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.link?.title ?? 'Contact Us'), 1)
            ]),
            _: 1
          }, 8, ["route"])
        ]),
        _: 1
      }),
      _createVNode(_component_Column, {
        class: "mt-16 md:mt-4",
        span: [ 2, 3 ]
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Paragraph, {
            class: "lg:px-10 agile-teams__content",
            innerHTML: _ctx.content
          }, null, 8, ["innerHTML"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}